// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2dI16","footer":"ModalFilter_footer__Pzipt"};